<template>
  <div class="page">
    <div
      class="groups-query-list card"
      :class="{ '-loading': loading }"
    >
      <loader v-if="loading"></loader>

      <div class="header">
        <div class="description">
          <h2 class="title">Consulta Recorrente</h2>
          <p class="subtitle">Nesta tela você cria e verifica as consultas recorrentes.</p>
        </div>

        <card-actions>
          <router-link
            :to="{ name: 'Recurrent-Create' }"
            class="btn btn-primary"
          >Nova Consulta Recorrente<ion-icon name="add"></ion-icon></router-link>
        </card-actions>
      </div>

      <div
        class="body"
        :class="{ '-no-padding' : !errors.cantLoadList && !errors.cantLoadGroupQueriesList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar suas consultas,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>
        <div class="alert -danger" v-if="errors.cantLoadGroupQueriesList">
          <template slot="title">Ops!</template>

          <p>
            Infelizmente aconteceu um erro ao tentar exibir os detalhes,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <template v-if="!errors.cantLoadList">
          <table class="list">
            <thead>
            <tr class="-head">
              <th>Nome</th>
              <th>Periodicidade</th>
              <th>Template</th>
              <th>Valor estimado</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="recurrent in recurrents.data">
              <tr
                class="row"
              >
                <td class="cell -queryinfo">{{ recurrent.name }}</td>
                <td class="cell -queryinfo">{{ findPeriodicitiy(recurrent.periodicity).label }}</td>
                <td class="cell -queryinfo">{{ recurrent.template_name }}</td>
                <td class="cell -queryinfo">R$  {{ recurrent.estimated_value | currency }}</td>
                <td class="cell -expanseaction">
                  <button class="btn -sm btn-primary" title="Editar template" @click="editRecurrent(recurrent.id)">
                    <ion-icon name="pencil" role="img" class="xs hydrated"></ion-icon>
                  </button>
                  <button class="btn -sm btn-default" title="Hitórico de Execuções" @click="showHistorical(recurrent.id)">
                    <ion-icon name="file-tray-full-outline" class="xs hydrated"></ion-icon>
                  </button>
                  <button class="btn -sm" :class="[ recurrent.enable ? 'btn-warning' : 'btn-success' ]" @click="toggle(recurrent)" title="">
                    {{ recurrent.enable ? 'Desabilitar' : 'Habilitar' }}
                  </button>
                  <button class="btn -sm btn-danger" title="Excluir" @click="deleteRecurrent(recurrent.id)">
                    <ion-icon name="trash" role="img" class="xs hydrated"></ion-icon>
                  </button>
                </td>
              </tr>
            </template>
            </tbody>
          </table>

          <div class="navList">
            <pagination
              :limit="1"
              :data="recurrents"
              @pagination-change-page="page = $event"
            >
              <span slot="prev-nav">Anterior</span>
              <span slot="next-nav">Próxima</span>
            </pagination>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import Loader from '@/support/components/Loader.vue';
import CardActions from '@/support/components/card/CardActions.vue';
import currency from '@/support/filters/currency';
import { mapState } from 'vuex';

export default {
  name: 'RecurrentIndex',

  data() {
    return {
      loading: false,
      page: 1,
      errors: {
        cantLoadList: false,
      },
    };
  },

  methods: {
    async fetchList() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch(
          'recurrent/fetchRecurrents',
          { page: this.page },
        );
      } catch {
        this.errors.cantLoadList = true;
      } finally {
        this.loading = false;
      }
    },

    resetErrors() {
      this.errors.cantLoadList = false;
      this.errors.cantLoadGroupQueriesList = false;
    },

    async deleteRecurrent(id) {
      this.loading = true;
      await this.$store.dispatch('recurrent/delete', id);
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: 'Consulta recorrente deletada com sucesso.',
      });
      await this.fetchList();
      this.loading = false;
    },

    async toggle(recurrent) {
      this.loading = true;
      await this.$store.dispatch('recurrent/toggle', recurrent.id);
      this.$notify({
        group: 'app',
        type: 'success',
        title: 'Sucesso!',
        text: `Consulta recorrente ${(recurrent.enable ? 'desabilitada' : 'habilitada')} com sucesso.`,
      });
      await this.fetchList();
      this.loading = false;
    },

    async editRecurrent(id) {
      await this.$router.push({
        name: 'Recurrent-Edit',
        params: { id },
      });
    },

    async showHistorical(id) {
      await this.$router.push({
        name: 'Recurrent-Historical',
        params: { id },
      });
    },

    findPeriodicitiy(value) {
      return this.periodicities.find((periodicity) => periodicity.value === value);
    },
  },

  mounted() {
    this.fetchList();
  },

  computed: {
    ...mapState('recurrent', {
      recurrents: 'recurrents',
      periodicities: 'periodicities',
    }),
  },

  filters: {
    currency,
  },

  watch: {
    page() {
      this.fetchList();
    },
  },

  components: {
    Pagination,
    Loader,
    CardActions,
  },
};
</script>

<style lang="scss" scoped>
.groups-query-list {
  > .body {
    > table.list {
      > thead,
      > tbody {
        > tr {
          > th,
          > td {
            padding-top: 0.8rem;
            padding-bottom: 0.8rem;

            .form-group {
              @apply mb-0;
            }

            &.-expanseaction {
              @apply text-center;
              @apply w-full;
              display: flex;
              justify-content: flex-end;
              gap: 8px;

              .btn {
                //padding: 0.2rem 0.5rem;

                > ion-icon {
                  left: 0;
                }
              }
            }
          }

          &.-head {
            @apply text-left;

            > .cell {
              @apply text-secondary-800;
              @apply text-xs;
              @apply font-bold;
            }
          }
        }
      }
    }

    > .navList {
      @apply flex;
      @apply justify-center;
    }
  }
}
</style>
